document.addEventListener('DOMContentLoaded', function () {
  const searchIcon = document.querySelector('.header__search_desktop');
  const mobileWrapper = document.querySelector('.header__search_mobile_wrapper');

  if (!searchIcon || !mobileWrapper) return;

  function moveSearchIcon() {
    if (window.innerWidth <= 1100) {
      // Move to mobile wrapper
      if (!mobileWrapper.contains(searchIcon)) {
        mobileWrapper.appendChild(searchIcon);
      }
    } else {
      // Optional: move it back to its original position on desktop
      const originalParent = document.querySelector('.header__search_desktop_original');

      if (originalParent && !originalParent.contains(searchIcon)) {
        originalParent.appendChild(searchIcon);
      }
    }
  }

  moveSearchIcon();
  window.addEventListener('resize', moveSearchIcon);
});